import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails
} from "amazon-cognito-identity-js";
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useInputChange } from '../../helpers/useInputChange'
import { useTranslation } from 'react-i18next';
import { initializeApps } from '../../helpers/applications'

const LoginPage = (params) => {

  const [email, setEmail] = useInputChange()
  const [password, setPassword] = useInputChange()
  const [error, setError] = useState()
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const redirect = urlParams.get('redirect')
    if (redirect && !redirect.endsWith("welcome")) {
      sessionStorage.setItem("redirect", redirect)
    } 
  })

  const onSubmit = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true
    var authenticationData = {
      Username: email,
      Password: password,
    };
    var authenticationDetails = new AuthenticationDetails(
      authenticationData
    );

    const userPool = new CognitoUserPool({
      UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
      ClientId: process.env.REACT_APP_COGNITO_CLIENTID,
    });

    var userData = {
      Username: email,
      Pool: userPool,
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        const queryParams = new URLSearchParams(location.search)
        const redirect = queryParams.get("redirect")
        onLoginSuccess(redirect)
      },

      onFailure: function (err) {
        button.clicked = false
        if (err.code == "UserNotConfirmedException") {
          setError((<>{err.message} <a href="/user/confirmation">{t("btn_account_confirm")}</a></>))
        } else {
          setError(err.message)
        }
      },
    });
  }

  const onLoginSuccess = async (redirect) => {
    await initializeApps()
    if (redirect) {
      history.push(redirect)
    } else {
      history.push("/workflows")
    }
  }

  document.title = t("titleappname") + t("title_login")

  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_login")}</h3>

      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="form-control"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_email")}
          onChange={setEmail}
          required={true} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>

      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_password")}</span>
        <input className="form-control"
          type="password"
          name="password"
          id="password"
          placeholder={t("tip_password")}
          onChange={setPassword}
          required={true} />
        <span className="focus-input100" data-symbol="&#xf023;"></span>
      </div>

      <div className="text-right">
        <a href="/user/forgottenpassword">{t("btn_forgotten_password")}</a>
      </div>
      {error ? <small id="errorMessage" className="text-danger">{error}<br /></small> : ""}
      <br />
      <div>
        <button className="submit-btn">{t("btn_login")}</button>
      </div>
      <br />
      <div>
        <a href="/user/signup">{t("btn_signup")}</a>
      </div>
    </form>
  </div>
}

export default LoginPage
